import React, { PureComponent } from "react";
import { reportAdrum } from "../../../utils/reportAdrum";

class ErrorBoundary extends PureComponent {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    try {
      let errorMsg = "";
      if (error) {
        errorMsg = error.toString();
      }

      if (errorInfo && errorInfo.componentStack) {
        errorMsg = `${errorMsg} || ${errorInfo.componentStack}`;
      }

      reportAdrum("Error Boundary Catch : " + errorMsg);
    } catch (e) {
      /* eslint-disable-next-line */
      console.log("ADRUM reporting failed!");
    }
  }

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <>
          <h3>Error occured</h3>
          <pre>{error.toString()}</pre>
        </>
      );
    }
    return children;
  }
}

export { ErrorBoundary };
